﻿import { Component } from "@angular/core";

@Component({
    selector: 'tfolio-cite',
    template: `
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 centered padded">
            <ng-content></ng-content>
        </div>
    </div>
</div>
`,
    styles: [`
.centered {
    text-align:center;
}
.padded {
    padding-top:50px;
}
`]
})
export class TFolioCiteComponent {
}